import { flexRender } from "@tanstack/react-table";
import { type PropsWithChildren, useEffect, useRef, useState } from "react";

import { DataTablePagination } from "@/components/shared/tables/DataTablePagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useAccountsTableInstanceContext } from "./table-instance-provider";

type Props = PropsWithChildren<{}>;

export const DataTable = ({ children }: Props) => {
  const tableRef = useRef(null);

  const { table } = useAccountsTableInstanceContext();

  return (
    <div className="flex flex-col gap-2">
      <div
        className="rounded-md border bg-background"
        style={{
          height: "calc(100vh - 217px)",
          overflowY: "auto",
          width: "100%",
        }}
      >
        <div className="flex flex-1">
          <Table ref={tableRef}>
            <TableHeader>
              {table.getHeaderGroups().map((headerGroup) => (
                <TableRow key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <TableHead
                        key={header.id}
                        colSpan={header.colSpan}
                        style={{
                          width: `${header.getSize()}px`,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          paddingLeft: header.id === "select" ? "15px" : "1px",
                        }}
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                      </TableHead>
                    );
                  })}
                </TableRow>
              ))}
            </TableHeader>
            <TableBody>
              {table?.getRowModel().rows.length ? (
                table?.getRowModel().rows.map((row) => (
                  <TableRow
                    key={row.id}
                    data-state={row.getIsSelected() && "selected"}
                  >
                    {row.getVisibleCells().map((cell: any) => {
                      const hasMeta =
                        cell.getContext().cell.column.columnDef.meta;
                      const style = hasMeta?.getCellContext(
                        cell.getContext(),
                      )?.style;
                      return (
                        <TableCell
                          key={cell.id}
                          style={{
                            paddingRight: "0px",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            paddingLeft: cell.id.includes("select")
                              ? "15px"
                              : "1px",

                            ...style,
                          }}
                          align={
                            hasMeta?.getCellContext(cell.getContext())?.align
                          }
                          className="truncate-short"
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={table.getAllColumns().length}
                    className="h-24 text-center"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {"Keine Ergebnisse"}
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {children ?? null}
        </div>
      </div>
      <DataTablePagination table={table} pageSizeOptions={[10, 50, 100, 200]} />
    </div>
  );
};
